export default {"src":"/planos/_next/static/media/equifax-file-analysis.635c7820.svg","height":38,"width":32,"blurWidth":0,"blurHeight":0};